import Home from "../views/Home.vue";
import MyCourses from "../views/MyCourses.vue";
import Profile from "../views/Profile.vue";
import Courses from "../views/Courses.vue";
import Course from "../views/Course.vue";
import Lecture from "../views/Lecture.vue";
import Exams from "../views/Exams.vue";
import MyExams from "../views/MyExams/MyExams.vue";
import MyHomeworks from "../views/MyExams/MyHomeworks.vue";
import WrongAnswers from "../views/MyExams/WrongAnswers.vue";
import Teachers from "../views/Teachers.vue";
import Teacher from "../views/Teacher.vue";
import SubjectTeachers from "../views/SubjectTeachers.vue";
import HonorPanel from "../views/HonorPanel.vue";
import Exam from "../views/Exam.vue";
import Wallet from "../views/Wallet/index.vue";
import Tours from "../views/Tours.vue";
import CenterWallet from "../views/CenterWallet/index.vue";
import Welcome from "../views/Welcome.vue";
import Support from "../views/Support.vue";
import Attachments from "../views/Attachments.vue";
import MyQuestions from "../views/BankQuestions/MyQuestions.vue";
import BankQuestions from "../views/BankQuestions/index.vue";
import OurOutlets from "../views/OurOutlets.vue";
import PracticeExams from '../views/MyExams/PracticeExams.vue';
const routes = [
    {path:'/my-exams/practice', name:'practice-exams', component:PracticeExams, meta:{title:'تدريباتي', requiresAuth:true}},
    {
        path: '/',
        name: 'welcome',
        component: Welcome,
        meta :{
            requiresAuth: false,
            requiresGuest: true,
            footer: {
                show: true,
                notFixed: true,
            },
            whiteBackground: true,
        }
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
        meta :{
            title: 'الصفحة الرئيسية',
            requiresAuth: true
        }
    },
    {
        path: '/courses',
        name: 'courses',
        component: Courses,
        meta :{
            title: 'الدورات التعليمية',
            // requiresAuth: true
        }
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
        meta :{
            title: 'الملف الشخصي',
            requiresAuth: true
            // whiteBackground: true,
        }
    },
    {
        path: '/my-courses',
        name: 'my-courses',
        component: MyCourses,
        meta :{
            title: 'دوراتي',
            requiresAuth: true
            // whiteBackground: true,
        }
    },
    {
        path: '/attachments',
        name: 'attachments',
        component: Attachments,
        meta :{
            title: 'مذكرات',
            whiteBackground: true,
        }
    },
    {
        path: '/our-outlets',
        name: 'our-outlets',
        component: OurOutlets,
        meta :{
            title: 'منافذنا',
            // whiteBackground: true,
        }
    },
    {
        path: '/courses/:id',
        name: 'course',
        component: Course,
        meta :{
            title: 'صفحة الدورة',
            backButton: true,
            // requiresAuth: true
            // temporaryMenu: true,
        }
    },
    {
        path: '/lectures/:id',
        name: 'lecture',
        component: Lecture,
        meta :{
            title: 'المحاضرة',
            backButton: true,
            requiresAuth: true
            // temporaryMenu: true,
        }
    },
    {
        path: '/teachers',
        name: 'teachers',
        component: Teachers,
        meta :{
            title: 'المعلمين',
            requiresAuth: true,
        }
    },
    {
        path: '/teachers/:id',
        name: 'teacher',
        component: Teacher,
        meta :{
            title: 'دورات المعلم',
        }
    },
    {
        path: '/subjects/:id',
        name: 'subject-teachers',
        component: SubjectTeachers,
        meta :{
            title: 'معلمو المادة',
            requiresAuth: true,
            backButton: true,
        }
    },
    {
        path: '/honor-panel',
        name: 'honor-panel',
        component: HonorPanel,
        meta :{
            title: 'لوحة الشرف',
            requiresAuth: true,
        }
    },
    {
        path: '/my-exams/exams',
        name: 'my-exams',
        component: MyExams,
        meta :{
            title: 'نتائج امتحاناتي',
            requiresAuth: true,
        }
    },
    {
        path: '/my-exams/homeworks',
        name: 'my-homeworks',
        component: MyHomeworks,
        meta :{
            title: 'نتائج واجباتي',
            requiresAuth: true,
        }
    },
    {
        path: '/my-exams/wrong-answers',
        name: 'wrong-answers',
        component: WrongAnswers,
        meta :{
            title: 'الأسئلة الخاطئة',
            requiresAuth: true,
        }
    },
    {
        path: '/exams',
        name: 'exams',
        component: Exams,
        props: true,
        meta :{
            title: 'الامتحان اﻹلكتروني',
            requiresAuth: true,
            temporaryMenu: true
        }
    },
    {
        path: '/exams/session',
        name: 'exam-session',
        component: Exam,
        props: true,
        meta :{
            title: 'الامتحان اﻹلكتروني',
            requiresAuth: true,
            temporaryMenu: true
        }
    },
    {
        path: '/wallet',
        name: 'wallet',
        component: Wallet,
        meta :{
            title: 'المحفظة الإلكترونية',
            requiresAuth: true
        }
    },
    {
        path: '/tours',
        name: 'tours',
        component: Tours,
        meta :{
            title: 'حجز الجولات',
            requiresAuth: true
        }
    },
    {
        path: '/center-wallet',
        name: 'center-wallet',
        component: CenterWallet,
        meta :{
            title: 'مدفوعات السنتر',
            requiresAuth: true
        }
    },
    {
        path: '/questions-bank/my-questions',
        name: 'my-questions',
        component: MyQuestions,
        meta :{
            title: 'أسئلتي',
            requiresAuth: true
        }
    },
    {
        path: '/questions-bank/directories',
        name: 'questions-bank',
        component: BankQuestions,
        meta :{
            title: 'بنك الأسئلة',
            requiresAuth: true
        }
    },
    {
        path: '/questions-bank/directories/:id',
        name: 'questions-bank-directory',
        component: BankQuestions,
        props: true,
        meta :{
            title: 'بنك الأسئلة',
            requiresAuth: true
        }
    },

    {
        path: '/login',
        name: 'login',
        component: () => import("../views/Login.vue"),
        meta :{
            title: 'تسجيل الدخول',
            requiresAuth: false,
            requiresGuest: true,
        }
    },
    {
        path: '/register',
        name: 'register',
        component: () => import("../views/Register.vue"),
        meta :{
            title: 'إنشاء حساب جديد',
            requiresAuth: false,
            requiresGuest: true,
        }
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        component: () => import( '../views/ResetPassword.vue'),
        meta :{
        title: 'استعادة كلمة المرور',
        requiresAuth: false,
        requiresGuest: true,
        }
    },
    {
        path: "/terms",
        name: "terms",
        component: () => import( '../views/Terms.vue'),
        meta: {
            title: 'شروط الاستخدام',
            footer: {
                show: true,
                notFixed: true,
            },
        }
    },
    {
    path: '/confirm',
    name: 'confirm',
    component: () => import( '../views/Confirm.vue'),
    meta :{
        title: 'تأكيد البريد الإلكتروني',
        requiresAuth: true,
    }
    },
    {
        path: "/links",
        name: "links",
        component: () => import("../views/Links.vue"),
        meta: {
            footer: {
                show: true,
            },
            title: 'روابطنا'
        }
    },
    {
        path: "/about",
        name: "about",
        component: () => import("../views/About.vue"),
        meta: {
            footer: {
                show: true,
                notFixed: true,
            },
            title: 'عن المنصة'
        }
    },
    {
        path: "/(privacy-policy|privacy)",
        name: "privacy-policy",
        component: () => import("../views/Privacy.vue"),
        meta: {
            footer: {
                show: true,
                notFixed: true,
            },
            title: 'سياسة الخصوصية',
        }
    },
    {
        path: "/help",
        name: "help",
        component: Support,
        meta: {
            title: 'الدعم الفني',
            footer: {
                show: true,
                notFixed: true,
            },
            whiteBackground: true,
        }
    },
    {
        path: '/center/registration/:form_id',
        name: 'center-registration',
        component: () => import('../views/CenterRegistration.vue'),
        props: true,
        meta: {
            title: 'تسجيل السنتر',
            requiresAuth: true,
            backButton: true,
            whiteBackground: true,
        }
    },
    {
        path: '*',
        name: 'not-found',
        meta: {
            title: 'الصفحة غير موجودة',
            footer: {
                show: true,
            },
            backIcon: true,
        },
        component: () => import(/* webpackChunkName: "about" */ '../views/NotFound.vue')
    }
  ];


  export default routes;